module.exports = __webpack_public_path__ + "static/media/city3.13a76684.jpg";